import { get, post, put } from "../Config";


export function CreateCollectPoint({ data }) {
  return post({ url: `/api/impact-admin/v1/collectPoint`,data});
}